import React from 'react';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import { DateFormats } from 'UI/constants/defaults';
import { toLocalTime } from 'UI/utils';

import { useStyles } from '../styles';

/**
 * @param {Object} props
 * @param {string} props.title
 * @param {string} props.createdBy
 * @param {string} props.createdAt
 */
const ChangeLogHeader = ({ title, createdBy, createdAt }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Typography variant="subtitle1" gutterBottom>
        {title}
      </Typography>

      <div className={classes.rowLabel}>
        <Typography className={clsx(classes.textContainer, classes.textLight)}>by</Typography>
        <Typography className={clsx(classes.textContainer, classes.textBold)}>
          {createdBy}
        </Typography>
        <Typography className={clsx(classes.textContainer, classes.textLight)}>at</Typography>
        <Typography className={clsx(classes.textContainer, classes.textBold)}>
          {toLocalTime(createdAt).format(DateFormats.SimpleDateTime)}
        </Typography>
      </div>
    </div>
  );
};

export default ChangeLogHeader;
